import React from 'react';

import { Box, Center, Loader } from '@mantine/core';

const Loading = (): JSX.Element => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Center data-testid='loading'>
        <Loader size='xl' variant='bars' />
      </Center>
    </Box>
  );
};

export default Loading;
